import { api } from '@shared/api';

export interface LightspeedOAuthAuthorizationUrlResponse {
  authorizationUrl: string | null;
}

export interface LightspeedOAuthConnectionResponse {
  isConnected: boolean;
  needsReauthorization: boolean;
  recentPushFailedAt: string | null;
  isOAuthConfigured: boolean;
  businessLocationId: string | null;
}

export interface LightspeedBusinessLocation {
  businessLocationId: string;
  name: string | null;
  street1: string | null;
  city: string | null;
  state: string | null;
  country: string | null;
}

export interface LightspeedBusinessLocationsResponse {
  businessLocations: LightspeedBusinessLocation[];
}

export const getLightspeedOAuthConnection = async (
  restaurantId: string,
): Promise<LightspeedOAuthConnectionResponse> =>
  api.get(`/restaurants/${restaurantId}/lightspeed/oauth-connection`);

export const getLightspeedOAuthAuthorizationUrl = async (
  restaurantId: string,
): Promise<LightspeedOAuthAuthorizationUrlResponse> =>
  api.get(`/restaurants/${restaurantId}/lightspeed/oauth-authorization-url`);

export const completeLightspeedOAuth = async (
  restaurantId: string,
  payload: { code: string; state: string },
): Promise<void> =>
  api.post(`/restaurants/${restaurantId}/lightspeed/oauth-token`, payload);

export const getLightspeedBusinessLocations = async (
  restaurantId: string,
): Promise<LightspeedBusinessLocationsResponse> =>
  api.get(`/restaurants/${restaurantId}/lightspeed/business-locations`);

export const setLightspeedBusinessLocation = async (
  restaurantId: string,
  businessLocationId: string,
): Promise<void> =>
  api.put(`/restaurants/${restaurantId}/lightspeed/business-location`, {
    businessLocationId,
  });

export const disconnectLightspeedIntegration = async (
  restaurantId: string,
): Promise<void> =>
  api.delete(`/restaurants/${restaurantId}/lightspeed/oauth-connection`);
